module.exports = __webpack_public_path__ + "0a9f116c48ca28952e7a916b0c255e1c.jpg";